// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LockedPost_wrapper__Z7Ksd","bg":"LockedPost_bg__ftTDJ","inner":"LockedPost_inner__6HWYZ","title":"LockedPost_title__P_LyP","btn":"LockedPost_btn__JCBe_"};